import { ParsedRowType, BindingDataDto } from "../types";

const INDEX_DEFAULT = "-1";

export const validateSave = (
  parsed: ParsedRowType[],
  bindings: BindingDataDto[],
  showDeviceId?: boolean
): { isValid: boolean; errorMessage: string } => {
  if (showDeviceId && !parsed.some(p => p.isDeviceId === true)) {
    return {
      isValid: false,
      errorMessage: "ByteArray veriler için bir DeviceId alanı seçilmelidir."
    };
  }

  const emptyParam = parsed.find(
    p => !p.parameterType || p.parameterType.trim() === ""
  );
  if (emptyParam) {
    return {
      isValid: false,
      errorMessage: "Parametre alanı zorunludur!"
    };
  }

  const normalize = (v: string) => v.trim().toLowerCase();
  const parsedNames = parsed.map(p => normalize(p.parameterType!));
  const bindingNames = bindings.map(b => normalize(b.name));
  const allNames = [...parsedNames, ...bindingNames];

  const nameCounts: Record<string, number> = {};
  allNames.forEach(name => {
    nameCounts[name] = (nameCounts[name] || 0) + 1;
  });

  const duplicateNames = Object.keys(nameCounts).filter(k => nameCounts[k] > 1);
  if (duplicateNames.length > 0) {
    return {
      isValid: false,
      errorMessage: `Aynı isim birden fazla yerde kullanılamaz: ${duplicateNames.join(", ")}`
    };
  }

  const invalidRow = parsed.find(
    p => !p.textValueConvert || p.textValueConvert.trim() === ""
  );
  if (invalidRow) {
    return {
      isValid: false,
      errorMessage: "Tüm satırlarda Değer alanları dolu olmalıdır!"
    };
  }

  const emptyNameIndex = bindings.findIndex(b => !b.name || b.name.trim() === "");
  if (emptyNameIndex !== -1) {
    return {
      isValid: false,
      errorMessage: `Parametre bağlama satırı ${emptyNameIndex + 1}: İsim zorunludur.`
    };
  }

  const hasDefaultIndex = bindings.some(b =>
    b.bindingParseData.some(p => p.itemId && p.itemId == INDEX_DEFAULT)
  );
  if (hasDefaultIndex) {
    return {
      isValid: false,
      errorMessage: "Lütfen tüm index alanlarında geçerli bir seçim yapınız."
    };
  }

  const hasLessThanTwoIndex = bindings.find(b => {
    const selectedIndexCount = b.bindingParseData.filter(p => !!p.itemId).length;
    return selectedIndexCount < 2;
  });
  if (hasLessThanTwoIndex) {
    return {
      isValid: false,
      errorMessage: "Parametre bağlamada her satır için en az 2 Index seçilmelidir."
    };
  }

  return { isValid: true, errorMessage: "" };
};
